module.exports = __webpack_public_path__ + "static/media/top-img_2_mob@2x.c9a5ec5b.png";